import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home, NotFound, UserPage, PostPage } from './pages';
import MainLayout from './components/MainLayout';

const App: React.FC = () => {
    return (
        <Router>
            <MainLayout>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/users/:username" element={<UserPage />} />
                    <Route path="/posts/:postId" element={<PostPage />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </MainLayout>
        </Router>
    );
}

export default App;
